import { Chip } from '@billda/design-system';

export type WorkerType = 'percentage' | 'fixedRate' | 'adhoc';

interface WorkerTypeChipProps {
  type: WorkerType;
  /** MUI chip size names — mapped onto DS sm/md */
  size?: 'small' | 'medium';
  /** Custom percentage value to display (e.g., 25.5 for "25.5% Split") */
  percentageValue?: number;
}

const chipConfig: Record<
  WorkerType,
  { label: string; color: 'secondary' | 'info' | 'warning' }
> = {
  percentage: { label: '% Split', color: 'secondary' },
  fixedRate: { label: 'Fixed Rate', color: 'info' },
  adhoc: { label: 'Ad-Hoc', color: 'warning' },
};

/** Worker type chip (DS fork of shared-ui WorkerTypeChip). */
export function WorkerTypeChip({
  type,
  size = 'small',
  percentageValue,
}: WorkerTypeChipProps) {
  const config = chipConfig[type];

  const label =
    type === 'percentage' && percentageValue != null
      ? `${percentageValue.toFixed(1)}% Split`
      : config.label;

  return (
    <Chip
      label={label}
      color={config.color}
      size={size === 'small' ? 'sm' : 'md'}
      variant="outlined"
    />
  );
}
